import React from "react";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";

export const NucTooltip = (props) => {
  return (
    <>
      <Tooltip
        disableFocusListener={props.disableFocusListener}
        disableTouchListener={props.disableTouchListener}
        title={props.title}
        id={props.id}
        arrow
      >
        {props.children}
      </Tooltip>
    </>
  );
};

NucTooltip.defaultProps = {
  title: "",
  id: "",
  children: null,
  disableFocusListener: false,
  disableTouchListener: false,
};

NucTooltip.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.any,
  disableFocusListener: PropTypes.bool,
  disableTouchListener: PropTypes.bool,
};
